"use strict";
/*
 * Created on 8.12.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var LockActionResult_1 = require("../model/LockActionResult");

var LockActionResultConverter_1 = require("./LockActionResultConverter");
/**
 * @author MSu
 */


var LockActionResultConverterImpl =
/*#__PURE__*/
function (_LockActionResultConv) {
  _inherits(LockActionResultConverterImpl, _LockActionResultConv);

  function LockActionResultConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, LockActionResultConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LockActionResultConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(LockActionResultConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new LockActionResult_1.LockActionResult(LockActionResult_1.LockActionResult.schema.resultType.valueOfField(source), source.lockOwner !== null ? this.userInfoConverter.toObject(source.lockOwner, conversions) : null, source.sessionId !== null ? conversions.toClassReferenceId(source.sessionId) : null);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        resultType: source.resultType,
        lockOwner: source.lockOwner !== null ? this.userInfoConverter.toDocument(source.lockOwner, conversions) : null,
        sessionId: source.sessionId !== null ? conversions.toDocumentReferenceId(source.sessionId) : null
      };
    }
  }]);

  return LockActionResultConverterImpl;
}(LockActionResultConverter_1.LockActionResultConverter);

LockActionResultConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], LockActionResultConverterImpl);
exports.LockActionResultConverterImpl = LockActionResultConverterImpl;